import {metadaApi} from '@dms/api/base';

import {
  GetServiceOrderVehicleClassApiArg,
  GetServiceOrderVehicleClassApiArgSchema,
  GetServiceOrderVehicleClassApiResponse,
  GetServiceOrderVehicleClassApiResponseSchema,
  PostServiceOrderAssignVehicleClassApiArg,
  PostServiceOrderAssignVehicleClassApiArgSchema,
  PostServiceOrderAssignVehicleClassApiResponse,
  PostServiceOrderAssignVehicleClassApiResponseSchema,
  PostServiceOrderUnassignVehicleClassApiArg,
  PostServiceOrderUnassignVehicleClassApiArgSchema,
  PostServiceOrderUnassignVehicleClassApiResponse,
  PostServiceOrderUnassignVehicleClassApiResponseSchema,
} from './types';

export const metadaWorkshopServiceOrderVehicleClassApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getServiceOrderVehicleClass: build.query<
      GetServiceOrderVehicleClassApiResponse,
      GetServiceOrderVehicleClassApiArg
    >({
      query: (queryArg) => ({
        url: `service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/vehicle-class`,
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'orderVehicleClass', id: queryArg.serviceOrderId},
      ],
      extraOptions: {
        responseSchema: GetServiceOrderVehicleClassApiResponseSchema,
        requestSchema: GetServiceOrderVehicleClassApiArgSchema,
      },
    }),
    postServiceOrderAssignVehicleClass: build.mutation<
      PostServiceOrderAssignVehicleClassApiResponse,
      PostServiceOrderAssignVehicleClassApiArg
    >({
      query: (queryArg) => ({
        url: `service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/assign-vehicle-class/${queryArg.vehicleClassId}`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'orderVehicleClass', id: queryArg.serviceOrderId},
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
        {type: 'serviceOrder', id: queryArg.serviceOrderId},
        {type: 'serviceOrderJobs', id: queryArg.serviceOrderId},
        {type: 'serviceOrderTotalAmount', id: queryArg.serviceOrderId},
        {type: 'orderProfitability', id: queryArg.serviceOrderId},
        {type: 'serviceOrderJobTotalAmount', id: queryArg.serviceOrderId},
        'checkout',
        'afsCheckout',
        'afsPaymentsList',
        {type: 'serviceOrderCheckoutRestriction', id: queryArg.serviceOrderId},
        'afsPaymentIssueRestriction',
        {type: 'serviceCaseTotalAmount', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        responseSchema: PostServiceOrderAssignVehicleClassApiResponseSchema,
        requestSchema: PostServiceOrderAssignVehicleClassApiArgSchema,
      },
    }),
    postServiceOrderUnassignVehicleClass: build.mutation<
      PostServiceOrderUnassignVehicleClassApiResponse,
      PostServiceOrderUnassignVehicleClassApiArg
    >({
      query: (queryArg) => ({
        url: `service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/unassign-vehicle-class`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'orderVehicleClass', id: queryArg.serviceOrderId},
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
        {type: 'serviceOrder', id: queryArg.serviceOrderId},
        {type: 'serviceOrderJobs', id: queryArg.serviceOrderId},
        {type: 'serviceOrderTotalAmount', id: queryArg.serviceOrderId},
        {type: 'orderProfitability', id: queryArg.serviceOrderId},
        {type: 'serviceOrderJobTotalAmount', id: queryArg.serviceOrderId},
        'checkout',
        'afsCheckout',
        'afsPaymentsList',
        {type: 'serviceOrderCheckoutRestriction', id: queryArg.serviceOrderId},
        'afsPaymentIssueRestriction',
        {type: 'serviceCaseTotalAmount', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        responseSchema: PostServiceOrderUnassignVehicleClassApiResponseSchema,
        requestSchema: PostServiceOrderUnassignVehicleClassApiArgSchema,
      },
    }),
  }),
});

export const {
  useGetServiceOrderVehicleClassQuery,
  usePostServiceOrderAssignVehicleClassMutation,
  usePostServiceOrderUnassignVehicleClassMutation,
} = metadaWorkshopServiceOrderVehicleClassApi;
